import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-next",
  "use": "icon-next-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-next\"><path d=\"M246.121 955.696l438.051-438.051c2.822-2.823 2.822-7.903 0-11.29l-439.18-439.18c-6.774-6.774-10.725-16.37-10.725-25.967v-4.516C234.267 16.37 250.637 0 270.959 0h4.516c9.597 0 19.193 3.951 25.967 10.725L780.137 489.42c12.419 12.419 12.419 32.741 0 45.16L302.57 1012.146c-7.338 7.338-17.5 11.854-28.225 11.854-22.015 0-40.08-18.064-40.08-40.08 0-10.16 4.517-20.321 11.855-28.224z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol